import { environment } from 'src/environments/environment';

export class BaseUrl {
  BASE_URL: string = environment.BASE_URL;
  NETHONE_SCRIPT_URL: string = environment.NETHONE_SCRIPT_URL;
  constructor() {}
}
